var map = {
	"./404.svg": "8e71",
	"./Glucose-Grey-scaled-1.png": "fc8e",
	"./arrow_back.svg": "d78f",
	"./background.png": "b874",
	"./cdi.png": "815c",
	"./closeup-unrecognizable-businesswoman-talking-pills-office_637285-4666-1.png": "d497",
	"./doc.png": "fa64",
	"./facebook.svg": "282f",
	"./fructose.jpg": "a4a4",
	"./glucose.jpg": "3736",
	"./info.svg": "50c1",
	"./lactose.jpg": "9d0a",
	"./lactulose.jpg": "9242",
	"./linkedin.svg": "0d29",
	"./logo_big.svg": "abd8",
	"./logo_header.svg": "8c3e",
	"./logo_header_on_white.svg": "685f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";